/**
 * Origens mark. Ring colors follow `--logo-ring-*` / `--logo-accent-*`
 * design tokens so the long navy arc lightens in dark mode.
 *
 * Gradient ids are stable string literals (not `useId()`): Go SSR and browser
 * hydration must agree on the `url(#…)` paint references. The mark renders
 * once per page, so a stable shared id is enough.
 *
 * Attributes stay explicit (no JSX spreads / module consts) for GoBeyond
 * portability (GB1030 / GB1070).
 */
export function OrigensLogo({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 384 384"
      role="img"
      aria-label="Origens logo"
      className={className}
    >
      <defs>
        <linearGradient
          id="origens-logo-navy"
          x1="192"
          y1="83"
          x2="192"
          y2="301"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="var(--logo-ring-start)" />
          <stop offset="1" stopColor="var(--logo-ring-end)" />
        </linearGradient>
        <linearGradient
          id="origens-logo-blue"
          x1="224"
          y1="238"
          x2="203"
          y2="301"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="var(--logo-accent-start)" />
          <stop offset="1" stopColor="var(--logo-accent-end)" />
        </linearGradient>
      </defs>
      <path
        fill="url(#origens-logo-navy)"
        fillRule="evenodd"
        d="M 160.13 296.24 A 109 109 0 1 1 282.37 252.95 L 248.37 230.03 A 68 68 0 1 0 172.12 257.03 Z"
      />
      <path
        fill="url(#origens-logo-blue)"
        fillRule="evenodd"
        d="M 276.11 261.33 A 109 109 0 0 1 173.07 299.34 L 180.19 258.97 A 68 68 0 0 0 244.47 235.25 Z"
      />
    </svg>
  )
}
